module.exports = __webpack_public_path__ + "img/Parts.a59c2987.png";